

// 定义公告得固定数据
export const topNavarr = [   // 导航二
	{ url: "/agency", link: "", name: "nav.Affiliate", isGame:false,
		// logoImg: require("./img/nav/r_affiliate.png"),
	},
	{ url: "/team", link: "", name: "nav.agency", isGame:false,
		// logoImg: require("./img/nav/r_affiliate.png"),
	},
	{ url: "", link: "", name: "nav.APPDownload", isGame: 'APPDownload',
		// logoImg: require("./img/nav/r_app.png"),
	},
]

export const topNavList = [ // 导航一
    {
        url: "/home",
        link: "",
        name: "nav.home",
        isGame: false,
        logoImg: require("../common/img/nav/top_nai_cricket.png"),
    },
    {
        url: "/games",
        link: "",
        name: "nav.games",
        isGame: false,
        logoImg: require("../common/img/nav/top_nai_games.png"),
    },	
    {
        url: "/sports",
        link: "",
        name: "nav.sport",
        isGame: false,
        logoImg: require("../common/img/nav/top_nai_sports.png"),
    },
    // {
    //     url: "/games",
    //     link: "",
    //     name: "nav.games",
    //     isGame: false,
    //     logoImg: require("../common/img/nav/top_nai_games.png"),
    // },
    // {
    //     url: "/team",
    //     link: "",
    //     name: "nav.team",
    //     isGame: false,
    //     logoImg: require("../common/img/nav/top_nai_team.png"),
    // },
    {
        url: "/discounts/all",
        link: "",
        name: "nav.discounts",
        isGame: false,
        logoImg: require("../common/img/nav/top_nai_promotions.png"),
    },
]

export const footerNav = [ // 底部
	// { url: "/team", link: "", name: "nav.team", isGame: false,},
	{ url: "/discounts/all", link: "", name: "nav.discounts", isGame: false,},
	{ url: "/agency", link: "", name: "nav.Affiliate", isGame: false,},
	{ url: "/helpCenter", link: "", name: "nav.contact", isGame: false,},
]

export const fixedTextList =[
	{  index:0, icon:require('../footer/img/h_card/bottom_bank.png'),},
	{  index:1, icon:require('../footer/img/h_card/bottom_phonepe.png'),}, 
	{  index:2, icon:require('../footer/img/h_card/bottom_paytm.png'),},
	{  index:3, icon:require('../footer/img/h_card/bottom_BHIM.png'),},
	{  index:4, icon:require('../footer/img/h_card/bottom_skrill.png'),},
	{  index:5, icon:require('../footer/img/h_card/bottom_neteller.png'),}
]



export const navData = [
	{
			name: 'mine.capital.deposit',
			url: '/mine/deposit',
			icon: require('../../views/mine/img/my_nai_deposit.png'),
			// icon02:require('./img/ac-deposit-p.png'),
			index:'0'
	},
	{
			name: 'mine.capital.latestDeposit',
			url: '/mine/latestDeposit',
			icon: require('../../views/mine/img/my_nai_lastest.png'),
			// icon02:require('./img/ac-deposit-p.png'),
			index:'19'
	},
	{
			name: 'mine.capital.withdrawal',
			url: '/mine/withdrawal',
			icon:require('../../views/mine/img/my_nai_withdraw_h.png'),
			// icon02:require('./img/ac-withdraw-p.png'),
			index:'1'
	},
	// {
	//     name: 'mine.capital.account',
	//     url: '/mine/account',
	//     icon:require('./img/ac-state-n.png'),
	//     icon02:require('./img/ac-state-p.png'),
	//     index:'2'
	// },
	{
			name: 'header.Betting',
			url: '/mine/betList',
			icon:require('../../views/mine/img/my_nai_betting.png'),
			// icon02:require('./img/ac-betting-p.png'),
			index:'3'
	},
	{
			name: 'header.transaction',
			url: '/mine/billDetail',
			icon:require('../../views/mine/img/my_nai_transaction.png'),
			// icon02:require('./img/ac-transaction-p-2.png'),
			index:'4'
	},
	{
			name: 'mine.capital.lockAmount',
			url: '/mine/lockAmount',
			icon:require('../../views/mine/img/my_nai_locked.png'),
			// icon02:require('./img/ac-transaction-p.png'),
			index:'5'
	},
	{
			name: 'mine.email.title',
			url: '/mine/inEmail',
			icon:require('../../views/mine/img/my_nai_message_h.png'),
			// icon02:require('./img/ac-fri-p.png'),
			index:'9'
	},
	{
			name: 'dialog.task',
			url: '/mine/task',
			icon:require('../../views/mine/img/my_nai_task.png'),
			index:'12'
	},
	{
			name: 'mine.friend',
			url: '/mine/invitation',
			icon:require('../../views/mine/img/my_nai_friend.png'),
			// icon02:require('./img/ac-fri-p-2.png'),
			index:'8'
	},
	{
			name: 'mine.AccountManagement',
			url: '/mine/safety',
			icon:require('../../views/mine/img/my_nai_account.png'),
			// icon02:require('./img/ac-manage-p.png'),
			index:'6'
	},
	// {
	//     name:'slot.mineCollect',
	//     url: '/mine/myCollect',
	//     index:'7',
	// },
 
	
]



// WEBPACK FOOTER //
// ./src/pages/build901/components/utils/Data.js